module.exports = __webpack_public_path__ + "static/media/cisco_cyberops_logo.3b2c5c66.png";